import { useCallback, useState } from 'react';

// TODO: monolu!

interface Props {
  initialized?: boolean;
}

interface Result {
  regenerateKey: () => void;
  key: string | null;
}

function useRandomKey({ initialized }: Props = {}): Result {
  const [key, setKey] = useState<string | null>(initialized ? Math.random().toString() : null);

  const regenerateKey = useCallback(() => {
    setKey(Math.random().toString());
  }, []);

  return {
    regenerateKey,
    key,
  };
}

export default useRandomKey;
